module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Landing-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComboActive && _vm.homeLandingBanners && _vm.homeLandingBanners.length),
      expression: "isComboActive && homeLandingBanners && homeLandingBanners.length"
    }],
    staticClass: "headtop prelative"
  }, _vm._l((_vm.homeLandingBanners), function(bimg, index) {
    return _c('div', {
      key: index
    }, [(bimg.image) ? _c('div', {
      staticClass: "prelative"
    }, [_c('router-link', {
      attrs: {
        "to": bimg.url ? bimg.url : '/men',
        "aria-label": bimg.promotion_name || 'Home Banner'
      }
    }, [_c('img', {
      staticClass: "fullWidth",
      attrs: {
        "src": _vm.isDesktop ? bimg.image : bimg.mobile_image,
        "alt": bimg.name || 'TSS Banner'
      }
    }), _vm._v(" "), (bimg.is_viewmore_button_visible) ? _c('div', {
      staticClass: "show-more-btn"
    }, [_c('span', {
      staticClass: "show-more-btn-txt"
    }, [_vm._v(_vm._s(bimg.name))])]) : _vm._e()]), _vm._v(" "), (bimg.is_split_banner) ? _c('div', {
      staticClass: "row splitted-navigation-container col-12"
    }, [_c('router-link', {
      staticClass: "col-6 h-100",
      attrs: {
        "to": bimg.url ? bimg.url : '/men',
        "aria-label": "left url"
      }
    }), _vm._v(" "), _c('router-link', {
      staticClass: "col-6 h-100",
      attrs: {
        "to": bimg.right_url ? bimg.right_url : '/men',
        "aria-label": "right url"
      }
    })], 1) : _vm._e()], 1) : _vm._e()])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dc2f2f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingPage.vue
// module id = 1002
// module chunks = 113